import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pay-dialog-close",
  "use": "icon-pay-dialog-close-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol viewBox=\"0 0 8 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pay-dialog-close\">\n<g id=\"icon-pay-dialog-close_Frame 35760\">\n<path id=\"icon-pay-dialog-close_Vector\" d=\"M7 7L1 1\" stroke=\"#606571\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path id=\"icon-pay-dialog-close_Vector_2\" d=\"M7 1L1 7\" stroke=\"#606571\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol